var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllEmptyFaultcodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_empty_faultcodes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 120,
    height: 120,
    rx: 60,
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task",
    transform: "translate(-406.298 -299.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H76.6V76.6H0Z",
    transform: "translate(428 316)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_warning",
    transform: "translate(435.658 326.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.361 0.085)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.626,7.9a5,5,0,0,1,8.749,0L57.892,48.578A5,5,0,0,1,53.517,56H8.483a5,5,0,0,1-4.374-7.422Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.99999809265137 5.323837280273438 C 29.28854751586914 5.323837280273438 27.57709503173828 6.183315277099609 26.62553405761719 7.902263641357422 L 4.108375549316406 48.57842254638672 C 2.263584136962891 51.91095352172852 4.673774719238281 56.00000381469727 8.482845306396484 55.99999237060547 L 53.51716613769531 55.99999237060547 C 53.51739501953125 55.99999237060547 53.51694488525391 55.99999237060547 53.51717758178711 55.99999237060547 C 57.32583618164062 55.99999237060547 59.73631286621094 51.91075134277344 57.89163208007812 48.57842254638672 L 35.37446594238281 7.902263641357422 C 34.42290496826172 6.183315277099609 32.71144866943359 5.323837280273438 30.99999809265137 5.323837280273438 M 30.9999942779541 3.323833465576172 C 32.21481323242188 3.323833465576172 33.40983581542969 3.636173248291016 34.45588302612305 4.227073669433594 C 35.56965637207031 4.856243133544922 36.49236297607422 5.792152404785156 37.12425231933594 6.933631896972656 L 59.64142227172852 47.60979461669922 C 60.85425567626953 49.80072402954102 60.81911468505859 52.39681243896484 59.54740524291992 54.55434417724609 C 58.27568435668945 56.7119026184082 56.02139282226562 57.99999237060547 53.51717376708984 57.99999237060547 L 8.482845306396484 57.99999237060547 C 5.978473663330078 58.00000381469727 3.724124908447266 56.71195220947266 2.452442169189453 54.55448150634766 C 1.180763244628906 52.39700317382812 1.145683288574219 49.80085372924805 2.358585357666016 47.60979461669922 L 24.8757438659668 6.933631896972656 C 25.50763320922852 5.792152404785156 26.43034362792969 4.856243133544922 27.54411315917969 4.227073669433594 C 28.59015274047852 3.636173248291016 29.78518295288086 3.323833465576172 30.9999942779541 3.323833465576172 Z",
    stroke: "none",
    fill: "#909090"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 4,
    height: 13.338,
    transform: "translate(28.639 23.639)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 4,
    height: 4,
    transform: "translate(28.639 41.424)",
    fill: "#909090"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEmptyFaultcodes);
export default __webpack_public_path__ + "static/media/ill_empty_faultcodes.d05b879c14e215f3d730e431e074d160.svg";
export { ForwardRef as ReactComponent };